<template>
    <div class="gear">
        <span
            v-for="(gear, index) of gears"
            :key="index"
            :class="{active: gear === position}"
            class="position"
        >{{gear}}</span>
    </div>
</template>

<script>
export default {
    name: "gear",

    props: {
        position: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            gears: ["P", "R", "N", "D"]
        };
    }
};
</script>

<style scoped>
.active {
    color: #413cf9;
}

.gear {
    font-weight: bold;
}

.position {
    margin-right: 20px;
}

.position:last-child {
    margin-right: 0;
}

@media screen and (min-width: 2048px) {
    .gear {
        font-size: 20px;
        line-height: 82px;
    }
}

@media screen and (max-width: 1920px) {
    .gear {
        font-size: 16px;
        line-height: 64px;
    }
}
</style>

